// ---------------------------------------------------------------------------
// F3b: lote da parede. A parede usa a cópia ADIADA do lote (React.useDeferredValue, C1 de antes): dentro da mesma
// série, isso só atrasa a parede um pouco. Logo depois de trocar de timeframe/ativo, porém, a cópia adiada ainda é da
// série ANTERIOR (no celular, por vários quadros): a parede desenhava velas de outro timeframe sobre a escala nova e a
// sonda acusava "FORA, Δx = 99, lote 0/0" (a vela do centro da parede não existe no lote do filamento). Nessa
// situação a parede usa o lote atual. `seriesId` NaN (dados sem etiqueta) conta como a mesma série.
// ---------------------------------------------------------------------------
export interface SeriesBatch { seriesId: number }
export function pickWallBatch<B extends SeriesBatch>(deferred: B, current: B): B {
  return Object.is(deferred.seriesId, current.seriesId) ? deferred : current;
}
